// IOSSwitch.js
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

const IOSSwitch = styled((props: SwitchProps & { onChange: (checked: boolean) => void }) => {
  const { onChange, ...otherProps } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (onChange) {
      // Toggle the checked state and call the onChange callback
      onChange(!props.checked);
    }
  };

  return <Switch onClick={handleClick} {...otherProps} />;
})();

export default IOSSwitch;
